export default __webpack_public_path__ + "static/media/icon.8d7b64e6.png";